<template>    
    <nav id="main-nav" class="flex-1 text-center">
        <ul>
            <li class="cursor-pointer group">
                <router-link active-class="active-menu" to="/" exact class="relative block w-full h-full my-4">
                    <div class="w-10 h-10 p-2 mx-auto rounded-full bg-background-menu group-hover:bg-hover-background-menu text-letter-menu group-hover:text-hover-letter-menu">
                        <svg viewBox="0 0 20 20" class="w-6 h-6 fill-current">
                            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                        </svg>
                    </div>
                </router-link>
            </li>
            <li class="cursor-pointer group">
                <router-link active-class="active-menu" to="/about" class="relative block w-full h-full my-4">
                    <div class="w-10 h-10 p-2 mx-auto rounded-full bg-background-menu group-hover:bg-hover-background-menu text-letter-menu group-hover:text-hover-letter-menu">
                        <svg viewBox="0 0 20 20" class="w-6 h-6 fill-current">
                            <path d="M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z" clip-rule="evenodd" fill-rule="evenodd">
                            </path>
                        </svg>
                    </div>
                </router-link>
            </li>
            <li class="cursor-pointer group">
                <router-link active-class="active-menu" to="/portfolio" class="relative block w-full h-full my-4">
                    <div class="w-10 h-10 p-2 mx-auto rounded-full bg-background-menu group-hover:bg-hover-background-menu text-letter-menu group-hover:text-hover-letter-menu">
                        <svg fill="currentColor" viewBox="0 0 20 20" class="w-6 h-6 fill-current">
                            <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"></path>
                            <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"></path>
                        </svg>
                    </div>
                </router-link>
            </li>
            <li class="cursor-pointer group">
                <router-link active-class="active-menu" to="/contact" class="relative block w-full h-full my-4">
                    <div class="w-10 h-10 p-2 mx-auto rounded-full bg-background-menu group-hover:bg-hover-background-menu text-letter-menu group-hover:text-hover-letter-menu">
                        <svg viewBox="0 0 20 20" class="w-6 h-6 fill-current">
                            <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"></path>
                            <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"></path>
                        </svg>
                    </div>
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
  name: 'Menu'
}
</script>
